import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { Action, applyMiddleware, compose, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { publicUrl } from "./config/config";
import api from "./middlwares/api";
import { rootReducer, RootState } from "./reducers/index";
import { resetApp } from "./store/appStatus";

export const history = createBrowserHistory({ basename: publicUrl });

const initialState = {};
const enhancers: any[] = [];
const middleware = [thunk, routerMiddleware(history), api];
const middlewareEnhancer = applyMiddleware(...middleware);

const composedEnhancers =
  process.env.NODE_ENV === "development"
    ? composeWithDevTools(middlewareEnhancer, ...enhancers)
    : compose(middlewareEnhancer, ...enhancers);

const resetEnhancer = (reducer: ReturnType<typeof rootReducer>) => (
  state: RootState,
  action: Action
) => {
  if (action.type !== resetApp.type) return reducer(state, action);

  localStorage.clear();
  const newState = reducer(undefined, { type: "EMPTY_ACTION" });
  newState.router = state.router;
  return newState;
};

const enhancedReducer = resetEnhancer(rootReducer(history));

//@ts-ignore State not matching for now
const store = createStore(enhancedReducer, initialState, composedEnhancers);

export default store;
